import { Injectable, InjectionToken } from '@angular/core';
import { Observable, } from 'rxjs';
import {
  EShoppingCartGetQueryType, ProductIdentifierDto, ShoppingCartSetItemDto, ShoppingCartCreateByTemplateCommandResult,
  ShoppingCartGetQueryResult, ShoppingCartSaveAsTemplateCommandResult, ShoppingCartSetOrderDataCommand,
  ShoppingCartSetOrderDataCommandResult, ShoppingCartDeleteCommandResult, ShoppingCartItemDeleteCommandResult,
  ShoppingCartItemSetCommandResult, ShoppingCartTemplateListGetQueryResult, ShoppingCartTemplateAddCommandResult, ShoppingCartValidateCommandResult,
} from 'projects/shared/lib/services/INTEGRA_Shop_Client';

@Injectable({
  providedIn: 'root'
})
export abstract class IShoppingCartApiService {
  abstract shoppingCartGet(shoppingCartGetQueryType: EShoppingCartGetQueryType, validateCart: boolean, cartNumber?: number | undefined, useCancellationLogic?: boolean | undefined): Observable<ShoppingCartGetQueryResult>;

  abstract shoppingCartTemplateListGet(): Observable<ShoppingCartTemplateListGetQueryResult>;

  abstract shoppingCartSaveAsTemplate(cartNumber: number, targetCartName: string): Observable<ShoppingCartSaveAsTemplateCommandResult>;

  abstract shoppingCartCreateByTemplate(cartNumber: number): Observable<ShoppingCartCreateByTemplateCommandResult>;

  abstract shoppingCartTemplateAdd(templateName: string, itemList?: ShoppingCartSetItemDto[] | undefined): Observable<ShoppingCartTemplateAddCommandResult>;

  abstract shoppingCartDelete(cartNumber: number): Observable<ShoppingCartDeleteCommandResult>;

  abstract shoppingCartItemDelete(productIdentifierList: ProductIdentifierDto[], cartNumber: number, validateCartAfterwards?: boolean | undefined): Observable<ShoppingCartItemDeleteCommandResult>;

  abstract shoppingCartItemSet(shoppingCartSetItemList: ShoppingCartSetItemDto[], cartNumber: number, deliveryDate: Date, validateCartAfterwards?: boolean | undefined): Observable<ShoppingCartItemSetCommandResult>;

  abstract shoppingCartSetOrderData(command: ShoppingCartSetOrderDataCommand): Observable<ShoppingCartSetOrderDataCommandResult>;

  abstract shoppingCartValidate(cartNumber: number): Observable<ShoppingCartValidateCommandResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IShoppingCartApiServiceToken = new InjectionToken<IShoppingCartApiService>('IShoppingCartApiServiceToken');
